import React, { useCallback } from 'react';
import { Card } from 'react-bootstrap';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { useNavigation } from '../../../common/navigation';
import { useAuth } from '../../../common/hooks/useAuth';
import { Role } from '../../../common/spdCore/authorization/roles';
import { SalesInvoiceSearch } from '../../components/SalesInvoice/SalesInvoicesSearch';

interface ExamInvoicesListProps {
  examId?: string;
}

export const ExamInvoicesList: React.FC<ExamInvoicesListProps> = ({
  examId,
}) => {
  const spd = useSpdCore();
  const nav = useNavigation();
  const auth = useAuth();

  const getData = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.salesInvoices.getAllByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        examId,
      ),
    [spd.salesInvoices, examId],
  );

  const getCount = useCallback(
    (filterText?: string, filterColumns?: string) =>
      spd.salesInvoices.getAllCount(
        filterText,
        filterColumns,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        examId,
      ),
    [spd.salesInvoices, examId],
  );

  return (
    <Card className="mb-3">
      <Card.Header>
        <Card.Title className="mb-0">Faktury do badania</Card.Title>
      </Card.Header>
      <Card.Body>
        <SalesInvoiceSearch
          getData={getData}
          getCount={getCount}
          onRowClick={
            auth.check([Role.Finance, Role.BasicFinance, Role.Admin])
              ? id => nav.salesInvoiceEditor(id)
              : undefined
          }
          withFilterInColumns={false}
          showFilter={false}
          withoutCorrectionButton={true}
          withHistory={false}
        />
      </Card.Body>
    </Card>
  );
};
